import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  POM = 801921
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const LOCKTYPE: { key: number, value: string, creatable: boolean }[] = [
  { key: 3, value: '3 Months', creatable: true },
  { key: 6, value: '6 Months', creatable: true },
  { key: 12, value: '12 Months', creatable: true }
]

export const SWEEPABLE: { key: number, value: string, creatable: boolean }[] = [
  { key: 0, value: 'Standard', creatable: true },
  { key: 1, value: 'Liquidity Locked', creatable: true },
  { key: 2, value: 'TokenA', creatable: false },
  { key: 3, value: 'TokenB', creatable: false }
]

export const FACTORY_ADDRESS = '0x56aBB5F0cF969c9301f4a35aA98E725d1d93cAEe'

export const INIT_CODE_HASH = '0xd8100ebe030810584687b6d039fde98fa7bd638ca8190a2b61883c27ee4828b6'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
